import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      tabActiveName: (state) => state.menu.globalMenuType
    })
  },
  mounted () {
    if (this.$route.path === '/shopiframe') {
      console.log('this.$router', this.$router)
      this.setGlobalMenuType('sale')
    }
  },
  methods: {
    ...mapMutations(['setGlobalMenuType']),
    handleTabClick (tab) {
      const { name } = tab
      if (name === this.tabActiveName) {
        return
      }

      if (name === 'sale') {
        this.setGlobalMenuType('sale')
        this.$router.push({ path: '/shopiframe', replace: true })
      } else if (name === 'wechat') {
        this.setGlobalMenuType('wechat')
        this.$router.go(-1)
      }
    }
  }
}
